<template lang="pug">
  div
    v-layout(row wrap)
      v-flex(xs12)
        Navbar(:backButtonPath="backPath")
      responsive-flex
        fan-loader(
          :loading="loading"
        )
          div(slot="loadingMsg"
            class="full-width text-xs-center headline my-2") Loading Finance Options...
        v-flex(v-if="!loading")
          h2.mt-5.text-sm-left Current Options:
          v-flex(v-if="activeLenders.length > 0")

            div.ma-3
              PorchPlanExpander
            v-flex(
              v-for="{lender_id, merchant_id} in [...activeLenders]"
              :key="lender_id"
              class="ma-3"
            )
              //TODO review lender logic
              div(v-if="lender_id === '1'")
                GreenskyPlanExpander(:merchantId="merchant_id" editable active)
              div(v-if="lender_id === '2'")
                FortivaPlanExpander(:merchantId="merchant_id" active)
              div(v-if="lender_id === '5'")
                MarlinPlanExpander(:merchantId="merchant_id" active)
              div(v-if="lender_id==='7'")
                WellsFargoPlanExpander(:merchantId="merchant_id" active editable)
          v-flex(v-else)
            v-img.mx-auto(:src="integrationImg" width="300px")
            .subheading.mt-3 No financing options available so far. 
            .subheading Go discover more available integrations below
          //- Discover More Integrations
          v-flex(v-if="Object.keys(additionalLenders).length > 0" class="xs12")
            h2.mt-5.text-sm-left Discover New Options:
              
          //Clearent
          v-flex(
            v-for="(lender, lenderName) in additionalLenders" :key="lenderName" 
            xs12 class="ma-3"
          )
            div(v-if="lenderName === 'greensky'")
              GreenskyPlanExpander( :merchantId="lender.merchantId" )
            div(v-if="lenderName === 'fortiva'")
              FortivaPlanExpander( :merchantId="lender.merchantId")
            div(v-if="lenderName === 'marlin'")
              MarlinPlanExpander( :merchantId="lender.merchantId" )
</template>

<script>
  import FanLoader from 'Components/FanLoader.vue'
  import Navbar from 'Components/Navbar.vue'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'
  import GreenskyPlanExpander from 'Components/GreenskyPlanExpander'
  import FortivaPlanExpander from 'Components/FortivaPlanExpander'
  import MarlinPlanExpander from 'Components/MarlinPlanExpander'
  import WellsFargoPlanExpander from 'Components/WellsFargoPlanExpander'
  import PorchPlanExpander from 'Components/PorchPlanExpander'
  import { delayMilliseconds } from 'Helpers/utilFunctions.js'
  import { mapGetters, mapState, mapActions } from 'vuex'

  export default {
    name: 'finance-options-view',
    components: {
      FanLoader,
      Navbar,
      ResponsiveFlex,
      FortivaPlanExpander,
      GreenskyPlanExpander,
      MarlinPlanExpander,
      WellsFargoPlanExpander,
      PorchPlanExpander
    },
    data () {
      return {
        backPath: '/home',
        integrationImg: require('Assets/integration.svg'),
        loading: true
      }
    },
    async mounted() {
      await delayMilliseconds(1000)
      try {
        await this.getClearentIntegrationStatus()
        this.loading = false
      } catch(error) {
        // this.error( error.response.data.message )
        this.loading = false
        return
      }
    },
    computed: {
      ...mapState({
        integrationId: state => state.integration.integrationId,
        lenders: state => state.user.lenders,
      }),
      ...mapGetters(['availableLenders']),
      clearentIntegrationActive() {
        return !!(this.integrationId)
      },
      activeLenders() {
        return this.availableLenders.filter(lender => lender.active === true )
      },
      additionalLenders() {
        let results = {}
        Object.keys(this.lenders).map((key) => {
          const lender = this.lenders[key]
          if ( lender === null ) {
            results[key] = {
              merchantId: null
            }
          } else if ( !lender.active && key !== 'wellsfargo') {
            results[key] = {
              merchantId: lender.merchant_id
            }
          }
        })
        return results
      }
    },
    methods: {
      ...mapActions([
        'getClearentIntegrationStatus'
      ])
    }
  }
</script>

<style lang="scss" scoped>
</style>
